import { uploadUrl } from '../api/api';
import { getVideoUrl } from './videoUtils';

export const resolvePodcastThumbnail = (podcast) => {
  const thumbnail = podcast?.thumbnail;
  if (!thumbnail || typeof thumbnail !== 'string') return null;
  if (thumbnail.startsWith('http://') || thumbnail.startsWith('https://') || thumbnail.startsWith('data:')) {
    return thumbnail;
  }
  if (thumbnail.startsWith('/uploads/')) {
    return `${uploadUrl}${thumbnail.replace('/uploads/', '/')}`;
  }
  return `${uploadUrl}/${encodeURIComponent(thumbnail)}`;
};

export const resolvePodcastAuthorPhoto = (podcast) => {
  const photo = podcast?.authorId?.photo || podcast?.authorPhoto;
  if (!photo || typeof photo !== 'string') return null;
  if (photo.startsWith('http://') || photo.startsWith('https://') || photo.startsWith('/')) {
    return photo.startsWith('/') && !photo.startsWith('http')
      ? `${uploadUrl}${photo.replace('/uploads/', '/')}`
      : photo;
  }
  return `${uploadUrl}/${encodeURIComponent(photo)}`;
};

export const getPodcastAuthorName = (podcast) =>
  podcast?.authorId?.name || podcast?.author || 'Unknown';

/** Raw video path/URL for OptimizedVideoPlayer (handles URL building internally). */
export const getPodcastVideoSource = (podcast) => {
  if (!podcast) return null;
  const formats = podcast.videoFormats || {};
  const candidates = [
    formats.mp4,
    podcast.video,
    formats.hls,
    formats.webm,
    formats.mov,
  ].filter(Boolean);
  return candidates[0] || null;
};

/** Best playable video source as a full URL for native video previews. */
export const resolvePodcastVideo = (podcast) => {
  const source = getPodcastVideoSource(podcast);
  if (!source) return null;
  return getVideoUrl(source);
};

export const getPodcastShareUrl = (podcastId) =>
  `${window.location.origin}/video-podcasts/${podcastId}`;

export const formatPodcastTime = (value) => {
  if (!value) return 'Recently';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Recently';
  return date.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getPodcastLikesCount = (podcast) =>
  Array.isArray(podcast?.likes) ? podcast.likes.length : 0;
